import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f7adafc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7adafc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f7adafc')) {
      api.createRecord('3f7adafc', component.options)
    } else {
      api.reload('3f7adafc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3f7adafc&scoped=true", function () {
      api.rerender('3f7adafc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/component/chooseGoods/index.vue"
export default component.exports